import * as Sentry from '@sentry/react';
import { isChunkLoadError } from './staleChunkReload';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: `bsr-system-registry@${import.meta.env.VITE_APP_VERSION || '0.0.0'}`,
    tracesSampleRate: 0.01,
    autoSessionTracking: false,
    // Stale hashed chunks after deploy — client auto-reloads; not an app bug.
    beforeSend(event, hint) {
      if (isChunkLoadError(hint?.originalException || hint?.syntheticException)) {
        return null;
      }
      const msg = event.exception?.values?.[0]?.value || event.message || '';
      if (isChunkLoadError(msg)) return null;
      return event;
    },
  });

  return true;
}

export { Sentry };
